import {
  COURT,
  ADDCOURT,
  ADDLOCNUMBER,
  LOCNUMBER,
  LOCTYPE,
  ADDLOCTYPE,
  ADDTYPEDAWA,
  TYPEDAWA,
  ADD_TAGADEDEFREE,
  TAKADEDEGREE,
  UPDATECOURT,
  DELETECOURT,
  DELETETYPEDAWA,
  UPDATETYPEDAWA,
  UPDATETAKADEDEGREE,
  DELETETAKADEDEGREE,
  UPDATELOCNUMBER,
  DELETELOCNUMBER,
  UPDATELOCTYPE,
  DELETELOCTYPE,
} from "../type";
const initialState = {
  AddCourts: [],
  Courts: [],
  UpdateCourts: [],
  DeleteCourts: [],

  AddLoctype: [],
  Loctype: [],
  DeleteLoctype: [],
  UpdateLoctype: [],

  AddLocNumber: [],
  LoctypeNumber: [],
  UpdateLoctypeNumber: [],
  DeleteLoctypeNumber: [],

  AddDawatype: [],
  Dawatype: [],
  UpdateDawatype: [],
  DeleteDawatype: [],

  AddDegreeTaqade: [],
  DegreeTaqade: [],
  UpdateDegreeTaqade: [],
  DeleteDegreeTaqade: [],
  
  loading: true,
};
const CourtR = (state = initialState, action) => {
  switch (action.type) {
    case COURT:
      return {
        ...state,
        Courts: action.payload,
        loading: false,
      };
    case ADDCOURT:
      return {
        Courts: state.Courts,
        AddCourts: action.payload,
        loading: false,
      };
    case UPDATECOURT:
      return {
        Courts: state.Courts,
        UpdateCourts: action.payload,
        loading: false,
      };
    case DELETECOURT:
      return {
        Courts: state.Courts,
        DeleteCourts: action.payload,
        loading: false,
      };
    case LOCNUMBER:
      return {
        ...state,
        LoctypeNumber: action.payload,
        loading: false,
      };
    case ADDLOCNUMBER:
      return {
        LoctypeNumber: state.LoctypeNumber,
        AddLocNumber: action.payload,
        loading: false,
      };
    case DELETELOCNUMBER:
      return {
        LoctypeNumber: state.LoctypeNumber,
        DeleteLoctypeNumber: action.payload,
        loading: false,
      };
    case UPDATELOCNUMBER:
      return {
        LoctypeNumber: state.LoctypeNumber,
        UpdateLoctypeNumber: action.payload,
        loading: false,
      };
    case LOCTYPE:
      return {
        ...state,
        Loctype: action.payload,
        loading: false,
      };
    case ADDLOCTYPE:
      return {
        Loctype: state.Loctype,
        AddLoctype: action.payload,
        loading: false,
      };
    case UPDATELOCTYPE:
      return {
        Loctype: state.Loctype,
        UpdateLoctype: action.payload,
        loading: false,
      };
    case DELETELOCTYPE:
      return {
        Loctype: state.Loctype,
        DeleteLoctype: action.payload,
        loading: false,
      };
    case TYPEDAWA:
      return {
        ...state,
        Dawatype: action.payload,
        loading: false,
      };
    case ADDTYPEDAWA:
      return {
        Dawatype: state.Dawatype,
        AddDawatype: action.payload,
        loading: false,
      };
    case DELETETYPEDAWA:
      return {
        Dawatype: state.Dawatype,

        DeleteDawatype: action.payload,
        loading: false,
      };
    case UPDATETYPEDAWA:
      return {
        Dawatype: state.Dawatype,

        UpdateDawatype: action.payload,
        loading: false,
      };
    case TAKADEDEGREE:
      return {
        ...state,
        DegreeTaqade: action.payload,
        loading: false,
      };
    case ADD_TAGADEDEFREE:
      return {
        DegreeTaqade: state.DegreeTaqade,
        AddDegreeTaqade: action.payload,
        loading: false,
      };
    case DELETETAKADEDEGREE:
      return {
        DegreeTaqade: state.DegreeTaqade,
        DeleteDegreeTaqade: action.payload,
        loading: false,
      };
    case UPDATETAKADEDEGREE:
      return {
        DegreeTaqade: state.DegreeTaqade,
        UpdateDegreeTaqade: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};
export default CourtR;
